import { createAction } from "@actionCreator";
import { SuccessMessage, ErrorMessage } from "../constants/actions";

import * as actions from "../constants/actions";
import { actionCreatorsFactory } from "@actionCreator";

export default actionCreatorsFactory(actions);

export const sendSuccessMessage = createAction(SuccessMessage);
export const sendErrorMessage = createAction(ErrorMessage);
